import {
  SortableContext,
  useSortable,
  horizontalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { KpiCard } from './KpiCard'
import type { KpiCardProps } from './KpiCard'

interface DraggableKpiStripProps {
  items: KpiCardProps[]
  editMode: boolean
}

function SortableKpiCard({ item, editMode }: { item: KpiCardProps; editMode: boolean }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
    disabled: !editMode,
  })

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        cursor: editMode ? 'default' : 'auto',
      }}
    >
      <KpiCard
        {...item}
        editMode={editMode}
        dragHandleProps={editMode ? { ...attributes, ...listeners } : undefined}
      />
    </div>
  )
}

export function DraggableKpiStrip({ items, editMode }: DraggableKpiStripProps) {
  return (
    <SortableContext items={items.map((i) => i.id)} strategy={horizontalListSortingStrategy}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 16,
        marginBottom: 24,
      }}>
        {items.map((item) => (
          <SortableKpiCard key={item.id} item={item} editMode={editMode} />
        ))}
      </div>
    </SortableContext>
  )
}
